
// this file is automatically generated by git.version.ts script
export const versions = {
  version: '2.4.0.4',
  revision: '9b8340428b52ec89a85f3678aeb1a52d6f6d9dcf',
  branch: 'release',
  channel: undefined,
  envTarget: undefined,
};